import React, { PureComponent, PropTypes } from 'react';
import { Link } from 'react-router';
import { getSubPageURL } from 'utils/utils';

export default class LinkSubPage extends PureComponent {
  static propTypes = {
    to: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    children: PropTypes.any,
  }

  get url() {
    const { to, location } = this.props;
    return to === '#' ? to : getSubPageURL(to, location);
  }

  get extraProps() {
    const extraProps = Object.assign({}, this.props);
    delete extraProps.to;
    delete extraProps.location;
    delete extraProps.children;
    return extraProps;
  }

  render() {
    return <Link to={this.url} rel="nofollow" {...this.extraProps}>{this.props.children}</Link>;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/LinkSubPage/LinkSubPage.jsx
 **/